#import "../../../../timeline/graphql/fragments/submission-fragment.graphql"

query GetSubmission($id: ID!) {
    submission(id: $id) {
        ...SubmissionFragment
    }
}
